module.exports = __webpack_public_path__ + "static/media/deepak-ghatole.0dec0206.jpg";